import React from 'react';

export const PreviewComponents = {
  p: ({node, ...props}) => (
    <p className="my-4 leading-relaxed whitespace-pre-wrap text-bw-ink" {...props} />
  ),
  strong: ({node, children}) => (
    <strong className="font-bold text-bw-ink">{children}</strong>
  ),
  em: ({node, children}) => (
    <em className="italic">{children}</em>
  ),

  // Headers - all levels
  h1: ({node, ...props}) => (
    <h1 className="text-3xl font-bold mt-8 mb-4 text-bw-ink" {...props} />
  ),
  h2: ({node, ...props}) => (
    <h2 className="text-2xl font-bold mt-6 mb-3 text-bw-ink" {...props} />
  ),
  h3: ({node, ...props}) => (
    <h3 className="text-xl font-bold mt-5 mb-2 text-bw-ink" {...props} />
  ),
  h4: ({node, ...props}) => (
    <h4 className="text-lg font-semibold mt-4 mb-2 text-bw-ink" {...props} />
  ),
  h5: ({node, ...props}) => (
    <h5 className="text-base font-semibold mt-3 mb-1 text-bw-ink" {...props} />
  ),
  h6: ({node, ...props}) => (
    <h6 className="text-sm font-semibold mt-3 mb-1 text-bw-muted" {...props} />
  ),

  // Lists
  ul: ({node, ordered, ...props}) => (
    <ul className="list-disc pl-6 my-4 space-y-2 text-bw-ink" {...props} />
  ),
  ol: ({node, ordered, ...props}) => (
    <ol className="list-decimal pl-6 my-4 space-y-2 text-bw-ink" {...props} />
  ),
  li: ({node, ...props}) => (
    <li className="pl-2" {...props} />
  ),

  // Tables - CRITICAL for pricing and compliance sections
  table: ({node, ...props}) => (
    <div className="my-6 overflow-x-auto">
      <table className="min-w-full border-collapse border border-bw-border bg-bw-surface" {...props} />
    </div>
  ),
  thead: ({node, ...props}) => (
    <thead className="bg-bw-surface-subtle" {...props} />
  ),
  tbody: ({node, ...props}) => (
    <tbody className="divide-y divide-bw-border" {...props} />
  ),
  tr: ({node, ...props}) => (
    <tr className="hover:bg-bw-surface-subtle" {...props} />
  ),
  th: ({node, ...props}) => (
    <th className="border border-bw-border px-4 py-3 text-left text-sm font-semibold text-bw-ink bg-bw-surface-subtle" {...props} />
  ),
  td: ({node, ...props}) => (
    <td className="border border-bw-border px-4 py-3 text-sm text-bw-ink" {...props} />
  ),

  // Blockquotes
  blockquote: ({node, ...props}) => (
    <blockquote className="border-l-4 border-bw-primary pl-4 my-4 italic bg-bw-surface-subtle py-2 text-bw-ink" {...props} />
  ),

  // Code
  code: ({node, inline, className, children, ...props}) => {
    return !inline ? (
      <pre className="bg-bw-surface-subtle border border-bw-border rounded-lg p-4 my-4 overflow-x-auto">
        <code className={className} {...props}>
          {children}
        </code>
      </pre>
    ) : (
      <code className="bg-bw-surface-subtle text-bw-ink rounded px-1 py-0.5 font-mono text-[0.9em]" {...props}>
        {children}
      </code>
    );
  },

  // Pre for code blocks
  pre: ({node, ...props}) => (
    <pre className="bg-bw-surface-subtle border border-bw-border rounded-lg p-4 my-4 overflow-x-auto text-sm" {...props} />
  ),

  // Links
  a: ({node, ...props}) => (
    <a
      className="text-bw-primary hover:text-bw-accent underline"
      target="_blank"
      rel="noopener noreferrer"
      {...props}
    />
  ),

  // Images
  img: ({node, ...props}) => (
    <img
      className="rounded-lg shadow-card my-6 max-w-full h-auto"
      loading="lazy"
      {...props}
    />
  ),

  // Horizontal rule
  hr: ({node, ...props}) => (
    <hr className="my-8 border-t border-bw-border" {...props} />
  )
};
